import styled from "styled-components";

const S = {
    Wrapper: styled.section`
        width: 100%;
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 60px;
    `,
    Top: styled.div`
        grid-area: headerleft;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 40px 40px;
        align-items: left;
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);

        @media (max-width: 648px){
            padding: 20px 16px;
        }
    `,
    Header: styled.h1`
        color: white;
        font-size: 28px;
        margin: 0;

        @media (max-width: 648px){
            font-size: 20px;
        }
    `,
    Span: styled.div`
        color: white;
        font-size: 14px;
        margin: 0;
        text-transform: capitalize;
        opacity: 0.9;
        a {
            color: white;
            text-decoration: none;
        }
    `,
    Sertifika: styled.div`
        grid-area: headerright;
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding: 0px 40px;
        align-items: center;

        @media (max-width: 648px){
            padding: 20px;
        }

        svg, img {
            margin: 5px;
            width: 50px;
            height: 70px;
            filter: invert(100%);

            @media (max-width: 648px){
                width: 30px;
                height: 30px;
            }
        }
    `,
    Section: styled.section`
        max-width: 800px;
        margin: 40px auto;
        padding: 40px;
        background: white;
        border-radius: 20px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: 20px 14px;
            padding: 24px 16px;
            border-radius: 16px;
        }

        h2 {
            color: #1e293b;
            font-size: 1.8em;
            margin-top: 0;
            margin-bottom: 30px;
            text-align: center;
            font-weight: 700;

            @media (max-width: 768px) {
                font-size: 1.35em;
                margin-bottom: 20px;
            }
        }

        .form {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 16px;

            input, textarea {
                width: 100%;
                padding: 14px 18px;
                border: 1px solid #e2e8f0;
                border-radius: 12px;
                background: #f8fafc;
                font-size: 1em;
                font-family: inherit;
                color: #334155;
                transition: all 0.3s ease;
                box-sizing: border-box;

                @media (max-width: 768px) {
                    padding: 12px 14px;
                    font-size: 0.95em;
                }

                &:focus {
                    outline: none;
                    border-color: #00A9C4;
                    background: #fff;
                    box-shadow: 0 0 0 4px rgba(0, 169, 196, 0.1);
                }
                
                &::placeholder {
                    color: #94a3b8;
                }
            }

            textarea {
                min-height: 120px;
                resize: vertical;
            }

            button {
                background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
                border: none;
                color: white;
                font-size: 1.05em;
                font-weight: 600;
                padding: 16px;
                border-radius: 12px;
                cursor: pointer;
                transition: all 0.2s ease;
                box-shadow: 0 10px 20px rgba(0, 169, 196, 0.2);
                margin-top: 10px;

                @media (max-width: 768px) {
                    padding: 14px;
                    font-size: 1em;
                }

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 15px 30px rgba(0, 169, 196, 0.3);
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }
    `
};

export default S;